/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import Markdown from "markdown-to-jsx";
import useMediaQuery from "@mui/material/useMediaQuery";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { getAboutUsDetails } from "./requestCall";
import { css } from "@emotion/react";
import { v4 } from "uuid";

const bannerWrapper = css`
  width: 100%;
  color: white;
  position: relative;
  img {
    width: 100%;
    vertical-align: bottom;
  }
  .MuiBackdrop-root {
    color: white;
  }
  .MuiTypography-h2 {
    position: absolute;
    top: 20px;
    left: 80px;
  }
  .MuiTypography-root {
    color: white;
  }
  .MuiTypography-body2 {
    position: absolute;
    bottom: 30px;
    left: 80px;
    width: 25%;
    height: 75px;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
`;
const cardWrapper = (direction, isImageRequiredOnRight) => css`
  background: #121212;
  .MuiBox-root {
    display: flex;
    align-items: center;
    img {
      width: ${direction === "row" ? "50%" : "100%"};
      order: ${direction === "row" && isImageRequiredOnRight === true ? 2 : -1};
    }
    .MuiCardContent-root {
      padding: 0;
      margin: 20px 0;
      width: ${direction === "row" ? "50%" : "100%"};
      .MuiTypography-root {
        margin: ${direction === "row" ? "30px 80px" : "10px 20px"};
        color: white;
      }
    }
  }
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const renderCard = (
  imgUrl,
  imgName,
  title,
  description,
  direction,
  isImageRequiredOnRight
) => {
  return (
    <Card css={() => cardWrapper(direction, isImageRequiredOnRight)} key={v4()}>
      <Box sx={{ display: "flex", flexDirection: direction }}>
        {imgUrl && (
          <CardMedia
            component="img"
            image={`${process.env.REACT_APP_BASEURL}${imgUrl}`}
            alt={imgName}
          />
        )}
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {title}
          </Typography>
          <Typography
            css={descriptionWrapper}
            variant="body2"
            color="text.secondary"
          >
            <Markdown>{description || ""}</Markdown>
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
};
const getMobileView = (banner, aboutUsData) => {
  return (
    <div>
      {banner?.map((bannerItem) =>
        renderCard(
          bannerItem?.bannerImage?.data?.attributes?.url,
          bannerItem?.bannerImage?.data?.attributes?.name,
          bannerItem?.title,
          bannerItem?.textTiles[0]?.description,
          "column"
        )
      )}
      {aboutUsData?.map((dataItem) =>
        renderCard(
          dataItem?.image?.data?.attributes?.url,
          dataItem?.image?.data?.attributes?.name,
          dataItem?.title,
          dataItem?.description,
          "column"
        )
      )}
    </div>
  );
};
const getDesktopView = (banner, aboutUsData) => {
  return (
    <div>
      {banner?.map((bannerItem, index) => (
        <Box css={bannerWrapper} key={`${bannerItem.id}_${index}`}>
          {bannerItem?.bannerImage?.data?.attributes?.url && (
            <img
              src={`${process.env.REACT_APP_BASEURL}${bannerItem?.bannerImage?.data?.attributes?.url}`}
              alt={`${process.env.REACT_APP_BASEURL}${bannerItem?.bannerImage?.data?.attributes?.name}`}
            />
          )}
          <Typography variant="h2">{bannerItem?.title}</Typography>
          <Typography variant="body2" component="div">
            {bannerItem?.textTiles?.map((textTilt) => (
              <Typography key={v4()} css={descriptionWrapper}>
                <Markdown>{textTilt.description || ""}</Markdown>
              </Typography>
            ))}
          </Typography>
        </Box>
      ))}
      {aboutUsData?.map((dataItem) =>
        renderCard(
          dataItem?.image?.data?.attributes?.url,
          dataItem?.image?.data?.attributes?.name,
          dataItem?.title,
          dataItem?.description,
          "row",
          dataItem?.isImageRequiredOnRight
        )
      )}
    </div>
  );
};
const AboutUs = () => {
  const [banner, setBanner] = useState([]);
  const [aboutUsData, setAboutUsData] = useState([]);
  const isMobile = useMediaQuery("(max-width: 480px)");
  useEffect(() => {
    getAboutUsDetails().then((response) => {
      document.title = response?.data?.data?.attributes?.title;
      const data = response?.data?.data?.attributes?.body;
      setBanner(data?.filter((i) => i.bannerImage));
      setAboutUsData(data?.filter((i) => i.image));
    });
  }, []);
  return (
    <div>
      {isMobile
        ? getMobileView(banner, aboutUsData)
        : getDesktopView(banner, aboutUsData)}
    </div>
  );
};

export default AboutUs;
